export { AwardsPressSection } from "../expanded-section-pack"
